export enum LSKey {

    LangCode = "__lang",
    Token = "__tkn",
    ChartSearch = "__crts",
    ServerToLocalhost = "__serverToLocalhost",
    SignUpSocialSource = "__suss",
    SignUpSocialToken = "__sust",
    SignUpSocialResponse = "__susr",
}

export interface Storage {

    setItem(key: string, value: string): void;

    getItem(key: string): Promise<string | null>;

    removeItem(key: string): void;
}
